import { render, staticRenderFns } from "./knowbefore.vue?vue&type=template&id=029e2e09&scoped=true&"
import script from "./knowbefore.vue?vue&type=script&lang=js&"
export * from "./knowbefore.vue?vue&type=script&lang=js&"
import style0 from "./knowbefore.vue?vue&type=style&index=0&id=029e2e09&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029e2e09",
  null
  
)

export default component.exports